/** Onboarding step labels shown in the homepage product preview (Figma 4890:13718). */
export const PRODUCT_PREVIEW_STEPS = [
  "Tell us about your business",
  "Securely connect your platforms",
  "Get approved for financing",
] as const;
